import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "flex justify-end" }
const _hoisted_2 = { class: "rounded-md space-y-3 pb-3" }

import {
    BlockArrayItems,
    BlockBaseElement,
    BlockDataValue,
} from "@/views/blocks/PageBlock.interface";
import { ButtonSecondaryIconSm, ButtonTertiaryIconXs } from "@easy/ui/buttons";
import { CardToggleAlt } from "@easy/ui/cards";
import { AddIcon, RecycleBinIcon } from "@easy/ui/icons";
import { BlockDefinition } from "@/apps/page/services/blocks/block.interfaces";
import type { PageSection } from "@/apps/page/page.interfaces";
import { Component } from "vue";
import { randomId } from "@/shared/utils/helpers";
import { FormInput, FormRichText, FormSelect, FormToggleSm } from "@easy/ui/forms";
import BlockImage from "./BlockImage.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'GroupItems',
  props: {
    groupedField: {},
    section: {},
    groupIcon: {}
  },
  setup(__props: any) {



function addItem() {
    (__props.section.dataValues[__props.groupedField.value].data as BlockArrayItems<unknown>).items.push({
        id: randomId(),
        ...__props.groupedField.defaultData,
    });
}

function removeItem(index: number) {
    (__props.section.dataValues[__props.groupedField.value].data as BlockArrayItems<unknown>).items.splice(
        index,
        1
    );
}

return (_ctx: any,_cache: any) => {
  const _component_FormTextArea = _resolveComponent("FormTextArea")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(ButtonSecondaryIconSm), {
        onClick: addItem,
        class: "flex gap-2"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(AddIcon))
        ]),
        _: 1
      })
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((
            _ctx.section.dataValues[_ctx.groupedField.value].data as BlockArrayItems<any>
        ).items, (item, index) => {
      return (_openBlock(), _createBlock(_unref(CardToggleAlt), {
        key: _ctx.groupedField.value + '_' + item.id,
        "data-field": _ctx.groupedField.value + '_' + item.id,
        title: _ctx.groupedField.label + ' ' + (index + 1),
        icon: _ctx.groupIcon
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedField.fields, (field) => {
              return (_openBlock(), _createElementBlock("div", {
                key: field.value
              }, [
                (field.type === 'text')
                  ? (_openBlock(), _createBlock(_unref(FormInput), {
                      key: 0,
                      id: field.value,
                      title: field.label,
                      modelValue: item[field.value],
                      "onUpdate:modelValue": ($event: any) => ((item[field.value]) = $event)
                    }, null, 8, ["id", "title", "modelValue", "onUpdate:modelValue"]))
                  : _createCommentVNode("", true),
                (field.type === 'select')
                  ? (_openBlock(), _createBlock(_unref(FormSelect), {
                      key: 1,
                      modelValue: item[field.value],
                      "onUpdate:modelValue": ($event: any) => ((item[field.value]) = $event),
                      label: field.label,
                      options: field.options,
                      value: item[field.value]
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "options", "value"]))
                  : _createCommentVNode("", true),
                (field.type === 'text')
                  ? (_openBlock(), _createBlock(_component_FormTextArea, {
                      key: 2,
                      id: field.value,
                      title: field.label,
                      modelValue: item[field.value],
                      "onUpdate:modelValue": ($event: any) => ((item[field.value]) = $event)
                    }, null, 8, ["id", "title", "modelValue", "onUpdate:modelValue"]))
                  : _createCommentVNode("", true),
                (field.type === 'html')
                  ? (_openBlock(), _createBlock(_unref(FormRichText), {
                      key: 3,
                      id: field.value,
                      title: field.label,
                      modelValue: item[field.value],
                      "onUpdate:modelValue": ($event: any) => ((item[field.value]) = $event),
                      rows: field.rows
                    }, null, 8, ["id", "title", "modelValue", "onUpdate:modelValue", "rows"]))
                  : _createCommentVNode("", true),
                (field.type === 'image')
                  ? (_openBlock(), _createBlock(BlockImage, {
                      key: 4,
                      id: field.value,
                      title: field.label,
                      modelValue: item[field.value],
                      "onUpdate:modelValue": ($event: any) => ((item[field.value]) = $event)
                    }, null, 8, ["id", "title", "modelValue", "onUpdate:modelValue"]))
                  : _createCommentVNode("", true),
                (field.type === 'switch')
                  ? (_openBlock(), _createBlock(_unref(FormToggleSm), {
                      key: 5,
                      id: field.value,
                      modelValue: item[field.value],
                      "onUpdate:modelValue": ($event: any) => ((item[field.value]) = $event),
                      title: field.label
                    }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "title"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]),
        actions: _withCtx(() => [
          _createVNode(_unref(ButtonTertiaryIconXs), {
            onClick: ($event: any) => (removeItem(index))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(RecycleBinIcon))
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _: 2
      }, 1032, ["data-field", "title", "icon"]))
    }), 128))
  ], 64))
}
}

})